import { tv } from "tailwind-variants";

import { CounterTheme } from "@/utils/enums";

import { TextSize } from "./boxCounter.types";

export const boxCounter = tv({
    base: [
        "box-counter",
        "tw:[&_.tick-credits]:hidden",
        "tw:in-[.box-banner--container]:text-[calc(100cqw*var(--box-text-width)/var(--box-text-length))]!"
    ],
    variants: {
        textSize: {
            [TextSize.SMALL]: [
                "tw:[--box-text-width:0.19]",
                "tw:text-[clamp(1.5rem,1.293rem+0.516vw,2.25rem)]"
            ],
            [TextSize.MEDIUM]: [
                "tw:[--box-text-width:0.29]",
                "tw:text-[clamp(1.75rem,1.35875rem+1.305vw,3.27rem)]"
            ],
            [TextSize.LARGE]: [
                "tw:[--box-text-width:0.38]",
                "tw:text-[clamp(2rem,1.5rem+3vw,5rem)]"
            ],
            [TextSize.EXTRA_LARGE]: [
                "tw:[--box-text-width:0.6]",
                "tw:text-[clamp(2.5rem,1.875rem+7.5vw,8rem)]"
            ]
        },
        theme: {
            [CounterTheme.LIGHT]: [
                "tw:[&_.tick-flip-panel]:text-black tw:[&_.tick-flip-panel]:bg-grey-light",
                "tw:[&_.tick-flip-panel-back-shadow]:bg-[linear-gradient(180deg,rgba(0,0,0,0.1),rgba(0,0,0,0.1))]",
                "tw:[&_.tick-flip-panel-front-shadow]:bg-[linear-gradient(0deg,rgba(0,0,0,0.4),rgba(0,0,0,0.1))]"
            ],
            [CounterTheme.DARK]: ""
        }
    },
    defaultVariants: {
        textSize: TextSize.MEDIUM,
        theme: CounterTheme.DARK
    }
});
